enum FastBoundDispositionRequestTypeEnum {
    REGULAR = "Regular",
    MANUFACTURING = "Manufacturing",
    NFA = "NFA",
    THEFT_LOSS = "TheftLoss",
    DESTROYED = "Destroyed",
}

export default FastBoundDispositionRequestTypeEnum;
